import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { ServicesModule } from "../services/services.module";
import { AuthGuard } from "./auth/auth.guard";

@NgModule({
  imports: [
    RouterModule,
    ServicesModule
  ],
  providers: [
    AuthGuard
  ]
})
export class GuardsModule {}



// WEBPACK FOOTER //
// ./src/app/common/guards/guards.module.ts